import { render, staticRenderFns } from "./RequestPassword.vue?vue&type=template&id=4966a1b5"
import script from "./RequestPassword.vue?vue&type=script&lang=js"
export * from "./RequestPassword.vue?vue&type=script&lang=js"
import style0 from "./RequestPassword.vue?vue&type=style&index=0&id=4966a1b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports